import React from "react";
import classes from "../TemplateGeneration.module.css";
import {Button} from "primereact/button";
import {isAuthorized} from "../../../../../../api/authorization/authorization-service";

const DownloadButton = ({templateIsDownloaded, downloadTemplate, dataCollection, uploadMethod}) => {
    return (
        <Button
            className={classes.templateBtn}
            label={uploadMethod === "xlsx-ttl" ? "Download template" : "Download BDS"}
            loading={templateIsDownloaded}
            icon="pi pi-download"
            onClick={downloadTemplate}
            disabled={(!isAuthorized("AR011"))}
        />)

}

export default DownloadButton;
